import React from "react";
import { getImageName } from "../../scripts/utils";

const mediaPrefix = `${process.env.MEDIA_URL}/media/images/icons/`;

const ImageStepItem = ({
  itemKey,
  name,
  className = "",
}: {
  itemKey: string;
  name: string;
  className?: string;
}) => {
  return (
    <div id={itemKey} className={`mmmTapesWalmart-image-selector ${className}`}>
      <div>
        <img
          srcSet={`${mediaPrefix}${getImageName(name)}.jpg 1x,
                    ${mediaPrefix}${getImageName(name)}@2x.jpg 2x,
                    ${mediaPrefix}${getImageName(name)}@3x.jpg 3x`}
          src={`${mediaPrefix}${getImageName(name)}.jpg `}
          alt={name}
        />
      </div>
      <p>{name}</p>
    </div>
  );
};

export default ImageStepItem;
